import { AlertTriangle } from 'lucide-react';
import { useData } from '../store/data';
import { isQuotaError } from '../../ledger/errors';

/** Báo ngay khi Firestore hết hạn mức trong ngày (dữ liệu hiện có thể cũ/thiếu, chưa lưu được). */
export default function QuotaBanner() {
  const quota = useData(s => Object.values(s.errors).some(m => isQuotaError({ message: m })));
  if (!quota) return null;
  return (
    <div role="alert" className="flex items-start gap-3 border-b border-bad/30 bg-bad-soft px-4 py-3 text-sm">
      <AlertTriangle size={18} className="mt-0.5 shrink-0 text-bad" aria-hidden />
      <p className="text-bad"><b>Firebase đã hết hạn mức miễn phí trong ngày.</b> Dữ liệu hiển thị có thể chưa đầy đủ và tạm thời chưa lưu được thay đổi mới. Hạn mức tự đặt lại khoảng 14:00 (giờ Việt Nam, 15:00 từ 1/11). Muốn bỏ giới hạn, nâng dự án lên gói Blaze trong Firebase Console.</p>
    </div>
  );
}
